
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'DeleteConfirmDialog',
  emits: ['update:modelValue', 'confirm'],
})
export default class DeleteConfirmDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly modelValue!: boolean
  @Prop({ type: String, default: '' }) readonly title!: string
  @Prop({ type: String, default: '' }) readonly message!: string
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean
}
